export default __webpack_public_path__ + "static/media/welc3.f91c23ed.gif";